export const MESSAGE_CONSTANTS = {
  TEMPLATE_DOWNLOADED: 'Plantilla descargada',
  TEMPLATE_DOWNLOAD_ERROR: 'Error al descargar la plantilla',
  MISSING_TYPE_OR_FILE: 'Selecciona un tipo de operación y un archivo',
  UPLOAD_GENERIC_ERROR: 'Ocurrió un error al procesar el archivo',
  REPORT_LOAD_ERROR: 'Error al cargar el reporte de cargas.',
  REPORT_LOAD_UNEXPECTED_ERROR:
    'Ocurrió un error inesperado al cargar el reporte de cargas.',
  REPORT_LOAD_DELETE_SUCCESS: 'La carga fue eliminada correctamente.',
  POLICY_NUMBER_GENERATION_ERROR: 'policyNumberGenerationError',
  REPORT_LOAD_DELETE_ERROR: 'No fue posible eliminar la carga.',
  FILE_VALIDATION_ERROR: 'El archivo tiene errores de validación.'
} as const;

export const KEY_MESSAGE = {
  UPLOAD_VALIDATION_SUMMARY: 'UPLOAD_VALIDATION_SUMMARY',
  UPLOAD_VALIDATION_FAILED: 'UPLOAD_VALIDATION_FAILED',
  RATE_LIMIT_EXCEEDED_CODE: 'RATE_LIMIT_EXCEEDED'
} as const;
